const RESEND_API_KEY = process.env.REACT_APP_RESEND_API_KEY;
const ADMIN_EMAIL = 'ndgije@gmail.com';
const FROM_EMAIL = 'report@brainoh.com';

export const sendServiceAlertEmail = async ({ driverName, vehiclePlate, vehicleInfo, odometerReading, nextServiceMileage, remaining }) => {
  if (!RESEND_API_KEY) {
    console.error('Resend API key not configured');
    return;
  }

  const isOverdue = remaining <= 0;

  const subject = isOverdue
    ? `⚠️ Service OVERDUE — ${vehiclePlate}`
    : `⚠️ Service Due Soon — ${vehiclePlate} (${remaining} km remaining)`;

  const html = `
    <div style="font-family: Arial, sans-serif; max-width: 600px; margin: 0 auto;">
      <div style="background: ${isOverdue ? '#dc2626' : '#f59e0b'}; padding: 20px; border-radius: 8px 8px 0 0;">
        <h1 style="color: white; margin: 0; font-size: 20px;">
          ${isOverdue ? '🚨 Service OVERDUE' : '⚠️ Service Due Soon'}
        </h1>
      </div>
      <div style="background: #f9fafb; padding: 24px; border-radius: 0 0 8px 8px; border: 1px solid #e5e7eb;">
        <p style="color: #374151; margin-top: 0;">A vehicle in your fleet ${isOverdue ? 'is overdue for service' : 'is approaching its service interval'}.</p>

        <table style="width: 100%; border-collapse: collapse; margin: 16px 0;">
          <tr style="background: #fff; border-bottom: 1px solid #e5e7eb;">
            <td style="padding: 10px 12px; color: #6b7280; font-size: 14px; width: 40%;">Vehicle</td>
            <td style="padding: 10px 12px; color: #111827; font-weight: 600; font-size: 14px;">${vehiclePlate} — ${vehicleInfo}</td>
          </tr>
          <tr style="background: #f9fafb; border-bottom: 1px solid #e5e7eb;">
            <td style="padding: 10px 12px; color: #6b7280; font-size: 14px;">Driver</td>
            <td style="padding: 10px 12px; color: #111827; font-weight: 600; font-size: 14px;">${driverName}</td>
          </tr>
          <tr style="background: #fff; border-bottom: 1px solid #e5e7eb;">
            <td style="padding: 10px 12px; color: #6b7280; font-size: 14px;">Current Odometer</td>
            <td style="padding: 10px 12px; color: #111827; font-weight: 600; font-size: 14px;">${odometerReading} km</td>
          </tr>
          <tr style="background: #f9fafb; border-bottom: 1px solid #e5e7eb;">
            <td style="padding: 10px 12px; color: #6b7280; font-size: 14px;">Next Service At</td>
            <td style="padding: 10px 12px; color: #111827; font-weight: 600; font-size: 14px;">${nextServiceMileage} km</td>
          </tr>
          <tr style="background: ${isOverdue ? '#fee2e2' : '#fef3c7'};">
            <td style="padding: 10px 12px; color: #6b7280; font-size: 14px;">Status</td>
            <td style="padding: 10px 12px; font-weight: 700; font-size: 14px; color: ${isOverdue ? '#dc2626' : '#d97706'};">
              ${isOverdue ? `Overdue by ${Math.abs(remaining)} km` : `${remaining} km remaining`}
            </td>
          </tr>
        </table>

        <p style="color: #374151; font-size: 14px;">Please schedule a service for this vehicle as soon as possible.</p>
        <p style="color: #9ca3af; font-size: 12px; margin-bottom: 0;">— Be Fleet System</p>
      </div>
    </div>
  `;

  try {
    const response = await fetch('https://api.resend.com/emails', {
      method: 'POST',
      headers: {
        'Authorization': `Bearer ${RESEND_API_KEY}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        from: FROM_EMAIL,
        to: ADMIN_EMAIL,
        subject,
        html,
      }),
    });

    if (!response.ok) {
      const err = await response.json();
      console.error('Resend error:', err);
    } else {
      console.log('Service alert email sent');
    }
  } catch (error) {
    console.error('Failed to send service alert email:', error);
  }
};
